import { createTheme } from '@ant-design/cssinjs';
import defaultDerivative from './index';

const defaultTheme = createTheme(defaultDerivative);

export default defaultTheme;
